export const SOCIAL_POST_METHOD_MANUAL = "manual"
export const SOCIAL_POST_METHOD_AUTO = "auto"
